import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "drawer-stub"
}
const _hoisted_2 = { class: "drawer-stub__content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "По этой команде ещё не было отчетов", -1)
const _hoisted_5 = {
  key: 1,
  class: "team-report-table mt-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "first-column" }, null, -1)
const _hoisted_7 = { class: "first-column" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "sprint-goal"
}
const _hoisted_10 = {
  key: 0,
  class: "yes"
}
const _hoisted_11 = {
  key: 1,
  class: "no"
}
const _hoisted_12 = {
  key: 0,
  class: "more-button"
}
const _hoisted_13 = {
  key: 0,
  class: "more-button"
}
const _hoisted_14 = {
  key: 5,
  class: "medium"
}
const _hoisted_15 = {
  key: 7,
  class: "stage-tasks-wrapper"
}
const _hoisted_16 = { class: "stage-tasks" }

import { useUiStore } from '@/stores/ui';
import { computed, onMounted } from 'vue';
import { useProgramsStore } from '@/stores/programs';
import { formApi } from '@/api/form';
import { useAccountStore } from '@/stores/account';
import TeamStatus from '@/components/TeamStatus.vue'
import { useDialogStore } from '@/stores/dialogs';
import CreateReportDialog from './dialogs/CreateReportDialog.vue';
import stubSvg from '@/assets/stub.svg'
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamReportTable',
  props: {
    team: null
  },
  setup(__props: any) {

const props = __props as { team?: any }

const uiStore = useUiStore()
const accountStore = useAccountStore()
const programsStore = useProgramsStore()


const team = computed<any>(() => {
   if (props.team) return props.team
   return uiStore.team
})

const fields = computed(() => {
   const teamName = team?.value.name
   const arr = []
   const keys = new Set([ "Достигнута ли цель спринта", "Состоялась ли встреча с командой", "Название программы" ])
   arr.push({ type: "sprintGoal", key: "Достигнута ли цель спринта", title: "Цель спринта" })
   arr.push({ type: "score", key: "diaryScore", title: "Дневник" })
   arr.push({ type: "score", key: "executionScore", title: "Execution" })
   arr.push({ type: "teamStatus", key: "date", title: "Статус" })
   arr.push({ type: "programStage", key: "programStageId", title: "Контрольная точка" })
   arr.push({ type: "stageTasks", key: "stageTasks", title: "Чек-лист", onClick: (report: any) => {
      uiStore.infoDrawer = { open: true, title: teamName, subtitle: "Чек-лист", stageTasks: report.stageTasks, checklist: programsStore.checklists[report.programStageId]?.all }
   } })

   for (let report of team?.value?.reports) {
      for (let key in report.fields) {
         if (keys.has(key)) continue
         keys.add(key)
         arr.push({ type: "otherField", key, title: key, class: "field", onClick: (report: any) => {
            uiStore.infoDrawer = { open: true, title: teamName, subtitle: key, content: report.fields[key] }
         } })
      }
   }
   arr.push({ type: "_otherField", class: "field", key: "resourceRequest", title: "Запрос на ресурсы", onClick: (report: any) => {
      uiStore.infoDrawer = { open: true, title: teamName, subtitle: "Запрос на ресурсы", content: report.resourceRequest || "Не было запроса на ресурсы" }
   }  })
   return arr
})

onMounted(async () => {
   await programsStore.requestChecklist()
})

const dialogStore = useDialogStore()
const editReport = (report: any) => {
   console.log(report)
   dialogStore.open(CreateReportDialog, { report })
}

const getReportName = (report: any) => {
   const index = weeks.value.findIndex(item => report.date > item[0] && report.date < item[1])
   return `TM${index+1} (${dayjs(report.date).format("DD.MM.YYYY")})`
}

const weeks = computed(() => {
   let arr: [string, string][] = []
   if (!team.value.reports) return arr
   for (let report of team.value.reports) {
      const date = dayjs(report.date)
      if (arr.length === 0 || report.date > arr[arr.length-1][1]) {
         arr.push([ date.startOf("week").toISOString(), date.endOf("week").toISOString() ])
      }
   }
   return arr
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_unref(team)?.reports?.length === 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(stubSvg),
            alt: "stub-content"
          }, null, 8, _hoisted_3),
          _hoisted_4
        ])
      ]))
    : (_unref(team)?.reports)
      ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(team)?.reports, (report, index) => {
                return (_openBlock(), _createElementBlock("th", null, [
                  _createTextVNode(_toDisplayString(getReportName(report)) + " ", 1),
                  (report.trackerId === _unref(accountStore).currentUser?.id)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "edit-button",
                        icon: "mdi-pencil",
                        size: "x-small",
                        variant: "flat",
                        onClick: ($event: any) => (editReport(report))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              }), 256))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", _hoisted_7, _toDisplayString(field.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(team)?.reports, (report) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: report.id,
                    class: _normalizeClass({ clickable: field.onClick }),
                    onClick: ($event: any) => (field.onClick && field.onClick(report))
                  }, [
                    (field.type === 'sprintGoal')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (report.fields[field.key] === 'Да')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-check",
                                  size: "small"
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-close",
                                  size: "small"
                                })
                              ]))
                        ]))
                      : (field.type === 'otherField')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(field.class)
                          }, [
                            _createTextVNode(_toDisplayString(report.fields[field.key]) + " ", 1),
                            (report.fields[field.key]?.length > 30)
                              ? (_openBlock(), _createElementBlock("button", _hoisted_12, "Ещё"))
                              : _createCommentVNode("", true)
                          ], 2))
                        : (field.type === '_otherField')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass(field.class)
                            }, [
                              _createTextVNode(_toDisplayString(report[field.key]) + " ", 1),
                              (report[field.key]?.length > 30)
                                ? (_openBlock(), _createElementBlock("button", _hoisted_13, "Ещё"))
                                : _createCommentVNode("", true)
                            ], 2))
                          : (field.type === 'field')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                class: _normalizeClass(field.class)
                              }, _toDisplayString(report[field.key]), 3))
                            : (field.type === 'score')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 4,
                                  class: _normalizeClass(report[field.key] < 4? 'red medium': 'medium')
                                }, _toDisplayString(report[field.key]), 3))
                              : (field.type === 'programStage')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(programsStore).stages.find(item => item.id === report[field.key])?.name), 1))
                                : (field.type === 'teamStatus')
                                  ? (_openBlock(), _createBlock(TeamStatus, {
                                      key: 6,
                                      "stage-id": report.programStageId,
                                      date: report.date
                                    }, null, 8, ["stage-id", "date"]))
                                  : (field.type === 'stageTasks')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programsStore).checklists[report.programStageId]?.all, (task) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: _normalizeClass({ checked: !!report.stageTasks.find((_task) => _task.id === task.id) })
                                            }, null, 2))
                                          }), 256))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("span", null, _toDisplayString(report.stageTasks.length), 1),
                                          _createTextVNode("/" + _toDisplayString(_unref(programsStore).checklists[report.programStageId]?.all.length), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                  ], 10, _hoisted_8))
                }), 128))
              ]))
            }), 256))
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})